import React from "react";
import mainContext from "./mainContext";
import { useState, useEffect, useCallback } from "react";
import { notification } from "antd";
import moment from "moment";
import getTotalValueDetails from "../valueDetails";
import getGstPerInventory from "../gstGstPerInventory";
import buyerDetails from "./buyerDetails";
import { useNavigate } from "react-router-dom";
import { getCurrentFinancialYear } from "../../../ReportContainer/utils/financialYearUtils";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const MainState = (props) => {
  const [id, setId] = useState(null);
  const [savedPageNumber, setSavedPageNumber] = useState(null);
  const [preservePageNumberOnNextListMount, setPreservePageNumberOnNextListMount] =
    useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [billings, setBillings] = useState([]);
  const [fetchToggle, setFetchToggle] = useState(false);
  const [salesMen, setSalesMen] = useState([]);
  const [createdByFilter, setCreatedByFilter] = useState(null);
  const [campaignDateRange, setCampaignDateRange] = useState(null);
  const [salesPersonFilter, setSalesPersonFilter] = useState(null);
  const [salesPersonOptions, setSalesPersonOptions] = useState([]);
  const [salesPersonLoading, setSalesPersonLoading] = useState(false);
  const [totalOrders, setTotalOrders] = useState(0);
  const [searchToggle, setSearchToggle] = useState(false);
  const [justView, setJustView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const [billingInvoiceIds, setBillingInvoiceIds] = useState([]);
  const [billingInvoices, setBillingInvoices] = useState([]);
  const [isArchivedbillingInvoices, setIsArchivedBillingInvoices] = useState(
    []
  );
  const [allSubInvoices, setAllSubInvoices] = useState([]);
  /** Total count for E-Invoices list (server-side pagination). */
  const [totalSubInvoices, setTotalSubInvoices] = useState(0);
  const [remark, setRemark] = useState("");
  const [parties, setParties] = useState([]);
  const [brands, setBrands] = useState([]);
  const [financialYear, setFinancialYear] = useState(getCurrentFinancialYear());
  const [nextBillNumber, setNextBillNumber] = useState("");
  const [consolidatedMode, setConsolidatedMode] = useState(false);
  const [consolidatedBillingIds, setConsolidatedBillingIds] = useState([]);
  const navigate = useNavigate();

  // Preserve pagination when returning from billing details (same pattern as Sales Order).
  const handleSetId = (nextId) => {
    if (nextId) {
      setConsolidatedMode(false);
      setConsolidatedBillingIds([]);
      setSavedPageNumber(pageNumber);
      setPreservePageNumberOnNextListMount(false);
      setId(nextId);
      return;
    }

    const hasSaved = savedPageNumber != null;
    if (hasSaved) {
      setPageNumber(savedPageNumber);
    }
    setSavedPageNumber(null);
    setPreservePageNumberOnNextListMount(hasSaved);
    setId(nextId);
  };

  const fetchNextBillNumber = useCallback(async () => {
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/returnNextBillNumber`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (result?.success && result?.data?.billNumber) {
        setNextBillNumber(result.data.billNumber);
      }
    } catch (err) {
      console.error("Failed to fetch next bill number:", err);
    }
  }, []);

  useEffect(() => {
    fetchNextBillNumber();
  }, [fetchNextBillNumber]);
  let AuthTokenNew = "";
  const [invoiceData, setInvoiceData] = useState({
    gstNumber: null,
    bdfType: null,
    stamp: null,
    roNumber: null,
    parentCompanyName: null,
    remark: null,
    roFile: null,
    brandName: null,
    taxType: null,
    agencyCommission: null,
    campaignDuration: null,
    inventories: [],
    suffixInventories: [],
    IRN: null,
    AckNo: null,
    AckDate: null,
    SignedInvoice: null,
    SignedQRCode: null,
    isRejected: null,
    cancelReason: null,
    //taxes
    taxType: 0,
    IGST: 0,
    SGST: 0,
    CGST: 0,
    municipalTax: 0,
    others: 0,
    round: 0,
    HSN: "",
  });

  const [archivedInvoiceData, setArchivedInvoiceData] = useState({
    gstNumber: null,
    bdfType: null,
    stamp: null,
    roNumber: null,
    parentCompanyName: null,
    remark: null,
    roFile: null,
    brandName: null,
    taxType: null,
    agencyCommission: null,
    campaignDuration: null,
    inventories: [],
    suffixInventories: [],
    IRN: null,
    AckNo: null,
    AckDate: null,
    SignedInvoice: null,
    SignedQRCode: null,
    isRejected: null,
    cancelReason: null,
    //taxes
    taxType: 0,
    IGST: 0,
    SGST: 0,
    CGST: 0,
    municipalTax: 0,
    others: 0,
    round: 0,
    HSN: "",
  });

  const [AuthToken, setAuthToken] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const openModal = () => setIsModalOpen(true); // Open modal function
  const closeModal = () => setIsModalOpen(false);
  useEffect(() => {
    if (AuthToken) {
      console.log("AuthToken Updated:", AuthToken);
    }
  }, [AuthToken]);

  const fetchSalesMen = useCallback(async () => {
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllSalesMen`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (response.ok && data?.success && Array.isArray(data?.data)) {
        setSalesMen(data.data);
      } else {
        setSalesMen([]);
      }
    } catch (error) {
      setSalesMen([]);
    }
  }, []);

  const fetchSalesPersons = useCallback(async () => {
    setSalesPersonLoading(true);
    try {
      const res = await fetch(
        `${apiBaseUrl}/inventoryManagement/listSalesPersons?page=1&limit=50`,
        { method: "GET", credentials: "include" },
      );
      const j = await res.json();
      if (res.ok && j?.success && Array.isArray(j?.data)) {
        const seen = new Set();
        const opts = j.data
          .map((s) => String(s?.name ?? "").trim())
          .filter((name) => {
            if (!name) return false;
            if (seen.has(name)) return false;
            seen.add(name);
            return true;
          })
          .sort((a, b) => a.localeCompare(b))
          .map((name) => ({ label: name, value: name }));
        setSalesPersonOptions(opts);
      } else {
        setSalesPersonOptions([]);
      }
    } catch (e) {
      setSalesPersonOptions([]);
    } finally {
      setSalesPersonLoading(false);
    }
  }, []);

  useEffect(() => {
    // Fetch once for the whole billing module (used by Pending/Completed filters).
    fetchSalesPersons();
  }, [fetchSalesPersons]);

  const fetchBillings = async (type = "pending") => {
    setLoading(true);
    try {
      const fyParam = `&financialYear=${encodeURIComponent(financialYear)}`;
      const createdByParam = createdByFilter
        ? `&createdBy=${encodeURIComponent(createdByFilter)}`
        : "";
      const salesPersonParam = salesPersonFilter
        ? `&salesPerson=${encodeURIComponent(salesPersonFilter)}`
        : "";
      const formatRangeDate = (d) => {
        if (!d) return "";
        // AntD v5 RangePicker returns Dayjs instances (have toDate()).
        // Some screens may still pass Moment instances (also have toDate()).
        if (typeof d?.toDate === "function") {
          return moment(d.toDate()).format("DD-MM-YYYY");
        }
        return moment(d).format("DD-MM-YYYY");
      };
      const campaignDateParam =
        Array.isArray(campaignDateRange) && campaignDateRange.length === 2
          ? `&campaignStartDate=${encodeURIComponent(
              formatRangeDate(campaignDateRange[0]),
            )}&campaignEndDate=${encodeURIComponent(
              formatRangeDate(campaignDateRange[1]),
            )}`
          : "";
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/listBillings?search=${searchQuery}&limit=${searchQuery ? 1000 : pageSize
        }&page=${searchQuery ? 1 : pageNumber}${createdByParam}${salesPersonParam}${campaignDateParam}&type=${type}${fyParam}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      if (response.ok) {
        let data = responseData?.data?.map((ele) => {
          return {
            ...ele.salesOrderId,
            createdAt: ele.createdAt,
            updatedAt: ele.updatedAt,
            billingId: ele._id,
            billingConfirmed: ele?.billingConfirmed,
            partyCompany: ele?.partyCompany,
            subTotal: ele?.subTotal,
            billNumbers: ele?.billNumbers || [],
            billingInfo: ele?.billingInfo || [],
            isConsolidatedSecondary: Boolean(ele?.isConsolidatedSecondary),
            primaryBillingId: ele?.primaryBillingId || null,
          };
        });
        setBillings(data);
        console.log("🔱🔱🔱🔱", data);
        setTotalOrders(responseData.totalBillings);
        if (searchQuery?.trim() === "") {
          setSearchToggle(false);
        } else {
          setSearchToggle(true);
        }
        return responseData;
      } else {
        notification.error({
          message: responseData?.message || "Failed to fetch bills",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error Occurred while fetching bills",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchPartiesAndBrands = async (type) => {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getBillingPartiesAndBrands?type=${type}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      if (response.ok) {
        setParties(responseData.parties || []);
        setBrands(responseData.brands || []);
      } else {
        notification.error({
          message:
            responseData?.message || "Failed to fetch parties and brands",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error Occurred while fetching parties and brands",
      });
    }
  };

  const fetchTotalBillingInvoices = async () => {
    if (!id) return; // ✅ Ensure `id` is present before making API call

    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllBillingInvoicesById?billingId=${id}`, // ✅ Pass id as billingId
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      if (response.ok) {
        setTotalInvoices(responseData.data.length); // ✅ Store response length in `totalInvoices`
        setBillingInvoiceIds(responseData.data.map((invoice) => invoice._id));
        setBillingInvoices(responseData.data);
      } else {
        setTotalInvoices(0);
        setBillingInvoices([]);
      }
    } catch (error) {
      notification.error({
        message: "Error occurred while fetching invoices",
      });
    }
  };

  const fetchTotalIsArchivedBillingInvoices = async () => {
    if (!id) return; // ✅ Ensure `id` is present before making API call

    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllisArchivedBillingInvoicesById?billingId=${id}`, // ✅ Pass id as billingId
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      if (response.ok) {
        setIsArchivedBillingInvoices(responseData.data);
      } else {
        setIsArchivedBillingInvoices([]);
      }
    } catch (error) {
      notification.error({
        message: "Error occurred while fetching invoices",
      });
    }
  };
  const token = window.localStorage.getItem("token");
  const roundToTwoDecimals = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return value;
    return Number(numericValue.toFixed(2));
  };

  const normalizeEInvoiceNumbers = (input) => {
    if (Array.isArray(input)) {
      return input.map((item) => normalizeEInvoiceNumbers(item));
    }

    if (input && typeof input === "object") {
      return Object.entries(input).reduce((acc, [key, value]) => {
        acc[key] = normalizeEInvoiceNumbers(value);
        return acc;
      }, {});
    }

    return typeof input === "number" ? roundToTwoDecimals(input) : input;
  };

  /** Server-side Microvista auth + DB persist (avoids browser CORS). */
  const refreshMicrovistaAuthToken = async () => {
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/refreshEinvToken`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.success === true && data.token) {
        setAuthToken(data.token);
        AuthTokenNew = data.token;
        return AuthTokenNew;
      }
      notification.error({
        message: data.message || "E-invoice authentication failed",
      });
    } catch (e) {
      console.error("refreshMicrovistaAuthToken:", e);
      notification.error({ message: "E-invoice authentication failed" });
    }
    return undefined;
  };

  const callEinvGeneration = async (requestBody) => {
    const response = await fetch(
      `${apiBaseUrl}/inventoryManagement/einvGeneration`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );
    return response.json();
  };

  const callEinvCancelIRN = async (requestBody) => {
    const response = await fetch(
      `${apiBaseUrl}/inventoryManagement/einvCancelIRN`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );
    return response.json();
  };

  const callEinvGetIRNDetails = async (requestBody) => {
    const response = await fetch(
      `${apiBaseUrl}/inventoryManagement/einvGetIRNDetails`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );
    return response.json();
  };

  // const getAuthToken = () => {
  //   console.log("I am clicked");
  //   generateEInvoice();
  // };
  const generateCreditNoteGov = async (
    gstNumber,
    inventories,
    HSN,
    cnNumber,
    invoiceData,
  ) => {
    let CnNumber = cnNumber;
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
      today.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${today.getFullYear()}`;
    const partyName = invoiceData?.splitAmount
      ? invoiceData?.splitParentCompanyName
      : invoiceData?.partyName || invoiceData?.parentCompanyName;
    const gstNumberFinal = invoiceData?.splitAmount
      ? invoiceData?.splitGSTNumber
      : invoiceData?.partyGstNumber || gstNumber;

    const buyerDetailsBook = await buyerDetails(gstNumberFinal, partyName);
    // Credit note must carry the same GST % as the saved invoice; if the doc
    // has none, the helpers fall back to the legacy 18% default.
    const savedTaxRates = {
      IGST: invoiceData?.IGST,
      SGST: invoiceData?.SGST,
      CGST: invoiceData?.CGST,
    };
    const requestBody = normalizeEInvoiceNumbers({
      Version: "1.1",
      TranDtls: {
        TaxSch: "GST",
        SupTyp: "B2B",
        IgstOnIntra: "N",
        RegRev: null,
        EcmGstin: null,
      },
      DocDtls: {
        Typ: "CRN",
        No: CnNumber,
        Dt: formattedDate,
      },
      SellerDtls: {
        Gstin: "24AADFY0077E1ZE",
        LglNm: "YELLOW SPOT OOH",
        TrdNm: "YELLOW SPOT OOH",
        Addr1: "12th Block, 4th Floor, Magnet Corporate Park,",
        Addr2: " Opp. Grand Cambay, Thaltej, Ahmedabad-380054",
        Loc: "Ahmedabad",
        Pin: 380054,
        Stcd: "24",
        Ph: "9033001770",
        Em: "accounts@yellowspot.in",
      },
      BuyerDtls: buyerDetailsBook,
      ValDtls: getTotalValueDetails(
        gstNumberFinal,
        inventories,
        "CRN",
        undefined,
        savedTaxRates
      ),
      ItemList: getGstPerInventory(
        gstNumberFinal,
        inventories,
        HSN,
        "CRN",
        undefined,
        savedTaxRates
      ),
    });
    try {
      const data = await callEinvGeneration(requestBody);

      if (data.Status == "1") {
        const datareq = {
          IRN: data.IRN,
          AckNumber: data.AckNo,
          AckDate: data.AckDate,
          SignedInvoice: data.SignedInvoice,
          SignedQrCode: data.SignedQRCode,
          CnNumber: CnNumber,
        };
        return datareq;
      }
      if (data.Status == "0") {
        const errorFromAPI = data.ErrorResponse[0].ErrorInfo;
        notification.error({ message: errorFromAPI });
      }
    } catch (error) {
      console.error("Error generating e-invoice:", error);
    }
  };

  const generateEInvoice = async (invoiceId, type, invoiceData) => {
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
      today.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${today.getFullYear()}`;
    console.log("invoicedatanew", invoiceData);
    const partyName = invoiceData?.splitAmount
      ? invoiceData?.splitParentCompanyName
      : invoiceData?.partyName || invoiceData?.parentCompanyName;
    const buyerDetailsBook = await buyerDetails(
      invoiceData?.splitAmount
        ? invoiceData?.splitGSTNumber
        : invoiceData?.partyGstNumber || invoiceData?.gstNumber,
      partyName
    );
    const generateDocumentNumber = () => {
      // DocDtls.No: use billNumber only (no B/CN prefix)
      return invoiceData?.billNumber;
    };
    const gstNumberFinal = invoiceData?.splitAmount
      ? invoiceData?.splitGSTNumber
      : invoiceData?.partyGstNumber || invoiceData?.gstNumber;
    const invoiceRootProductionCharges = {
      printingCharge: invoiceData?.printingCharge,
      mountingCharge: invoiceData?.mountingCharge,
    };
    // GST % saved on the invoice — this is what must reach the govt API.
    const savedTaxRates = {
      IGST: invoiceData?.IGST,
      SGST: invoiceData?.SGST,
      CGST: invoiceData?.CGST,
    };
    const requestBody = normalizeEInvoiceNumbers({
      Version: "1.1",
      TranDtls: {
        TaxSch: "GST",
        SupTyp: "B2B",
        IgstOnIntra: "N",
      },
      DocDtls: {
        Typ: type,
        No: generateDocumentNumber(),
        Dt: formattedDate,
      },
      SellerDtls: {
        Gstin: "24AADFY0077E1ZE",
        LglNm: "YELLOW SPOT OOH",
        TrdNm: "YELLOW SPOT OOH",
        Addr1: "12th Block, 4th Floor, Magnet Corporate Park,",
        Addr2: " Opp. Grand Cambay, Thaltej, Ahmedabad-380054",
        Loc: "Ahmedabad",
        Pin: 380054,
        Stcd: "24",
        Ph: "9033001770",
        Em: "accounts@yellowspot.in",
      },
      BuyerDtls: buyerDetailsBook,
      ValDtls: getTotalValueDetails(
        gstNumberFinal,
        invoiceData?.billedInvs,
        undefined,
        invoiceRootProductionCharges,
        savedTaxRates
      ),
      ItemList: getGstPerInventory(
        gstNumberFinal,
        invoiceData?.billedInvs,
        invoiceData?.HSN,
        undefined,
        invoiceRootProductionCharges,
        savedTaxRates
      ),
    });

    // console.log("requestBody::", requestBody);
    try {
      const data = await callEinvGeneration(requestBody);
      console.log("E-Invoice Response:", data);
      if (type == "CRN" && data.Status == "1") {
        const cn = await generateCreditNote(data, generateDocumentNumber());
        if (cn) {
          notification.success({ message: "Credit Generated" });
        }
        notification.error({ message: "Some error occurred" });
        return;
      }
      if (data.Status == "1") {
        const reqBody = {
          invoiceId,
          IRN: data.IRN,
          AckNo: data.AckNo,
          AckDate: data.AckDate,
          SignedInvoice: data.SignedInvoice,
          SignedQrCode: data.SignedQRCode,
        };
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/addIRNInInvoice`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(reqBody),
          }
        );
        const data2 = await response.json();
        if (data2.success == true) {
          setInvoiceData((prevState) => ({
            ...prevState,
            IRN: data2.IRN,
            AckNo: data2.AckNo,
            AckDate: data2.AckDate,
            SignedInvoice: data2.SignedInvoice,
            SignedQrCode: data2.SignedQRCode,
          }));
          notification.success({ message: "E-invoice created successfully" });
          navigate("/billing?tab=4");
          handleSetId(null);
        }
      } else if (data.Status == 0) {
        const errorFromAPI = data.ErrorResponse[0].ErrorInfo;
        notification.error({ message: errorFromAPI });
      }
    } catch (error) {
      console.error("Error generating e-invoice:", error);
    }
  };
  const cancelInvoice = async (IRN) => {
    try {
      const requestBody = {
        CnlRsn: "1",
        CnlRem: remark,
        Irn: IRN,
      };
      const data = await callEinvCancelIRN(requestBody);

      if (data.Status == "1") {
        return true;
      } else {
        notification.error({ message: data?.ErrorMessage });
        return false;
      }
    } catch (error) {
      console.log("Error in cancelling the Invoice", error.message);
      return false;
    }
  };
  const getIrnDetails = async (IRN) => {
    console.log("this iss the irm from getIrnDetails", IRN);
    try {
      const data = await callEinvGetIRNDetails({ IRN });
      if (data.Status == "1") {
        console.log("These are the IRN details", data);
        notification.success({ message: "fetched successfully" });
      } else {
        notification.error({ message: data.ErrorMessage });
      }
    } catch (error) {
      console.log("Error in getting information", error.message);
    }
  };
  /** @param {boolean} [forceRefresh] Skip DB cache and get a new token from Microvista (e.g. after 1005). */
  const checkAuthToken = async (forceRefresh = false) => {
    if (!forceRefresh) {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAuthToken`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.success == true) {
        console.log("It is going in the success of 1st api", data.token);
        setAuthToken(data.token);
        AuthTokenNew = data.token;
        console.log("from", AuthTokenNew);
        return AuthTokenNew;
      }
    }
    return refreshMicrovistaAuthToken();
  };
  /**
   * E-Invoices list — same pagination contract as listBillings: `page` + `limit`.
   * Backend should return `records` (current page) and total count (`total` or `totalSubInvoices`).
   */
  const getAllSubInvoice = useCallback(async () => {
    const authToken = window.localStorage.getItem("token");
    setLoading(true);
    try {
      const fyParam = `&financialYear=${encodeURIComponent(financialYear)}`;
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllSubinvoices?search=${searchQuery}&limit=${searchQuery ? 1000 : pageSize}&page=${searchQuery ? 1 : pageNumber}${fyParam}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${authToken}`,
          },
        }
      );
      const data = await response.json();
      console.log("data from the get all sub invoice", data);
      if (data.success) {
        setAllSubInvoices(data.records || []);
        const total =
          data.total ??
          data.totalSubInvoices ??
          data.totalCount ??
          data.totalRecords ??
          0;
        setTotalSubInvoices(Number(total) || 0);
      } else {
        notification.message({ message: data.message });
        setAllSubInvoices([]);
        setTotalSubInvoices(0);
      }
      return data;
    } catch (err) {
      console.error("getAllSubInvoice", err);
      notification.error({ message: err?.message || "Failed to load E-Invoices" });
      setAllSubInvoices([]);
      setTotalSubInvoices(0);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [pageNumber, pageSize, financialYear, searchQuery, fetchToggle]);
  const generateCreditNote = async (creditNoteData, docNumber) => {
    const reqBody = {
      ...creditNoteData,
      DocNo: docNumber,
    };
    const response = await fetch(
      `${apiBaseUrl}/inventoryManagement/generateCreditNote`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${token}`,
        },
        body: JSON.stringify(reqBody),
      }
    );
    const responseData = await response.json();
    if (responseData) {
      return true;
    }
  };

  // Add this function inside your MainState component:

  const cancelBillingInvoice = async (invoiceId, remark) => {
    try {
      if (!invoiceId) {
        notification.error({
          message: "Invoice ID is required.",
        });
        return false;
      }

      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/cancelBillingInvoice?invoiceId=${invoiceId}&remark=${remark}`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        handleSetId(null);
        setRemark("");
        navigate("/billing?tab=1");
        notification.success({
          message: responseData.message || "Invoice canceled successfully.",
        });
      } else {
        notification.error({
          message: responseData.message || "Failed to cancel invoice.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error occurred while canceling invoice: " + error.message,
      });
      return false;
    }
  };

  const fetchArchivedInvoiceDataByID = async (archivedInvoiceId) => {
    try {
      if (archivedInvoiceId) {
        let response = await fetch(
          `${apiBaseUrl}/inventoryManagement/getInvoiceDataById?invoiceId=${archivedInvoiceId}`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const responseData = await response.json();

        if (response.ok) {
          const invoiceInfo = responseData.invoiceInfo.salesOrderId || {};
          const bdfId = invoiceInfo?.bdfId || {};
          const rootParty = responseData?.invoiceInfo?.party || {};
          const rootBrand = responseData?.invoiceInfo?.brand || {};
          const billingPartyCompany =
            responseData?.invoiceInfo?.billingId?.partyCompany || {};
          const partyCompany = bdfId?.parentCompanyId || {};
          const billedInvs = responseData.invoiceInfo?.inventories || [];
          const billedSuffixInvs =
            responseData.invoiceInfo?.suffixInventories || [];

          // console.log("😿🟢🟢", invoiceInfo);
          setArchivedInvoiceData({
            // billingId: id,
            // salesOrderId: invoiceInfo?._id,
            HSN: responseData?.invoiceInfo?.HSN,
            IRN: responseData?.invoiceInfo?.IRN,
            bdfDate:
              responseData?.invoiceInfo?.salesOrderId?.bdfId?.bdfDate ?? null,
            isRejected: responseData?.invoiceInfo?.isRejected,
            cancelReason: responseData?.invoiceInfo?.cancelremark,
            bdfId: bdfId?._id,
            salesPerson: bdfId?.salesPerson,
            bdfStamp: bdfId?.stamp,
            partyName: rootParty?.name || null,
            partyGstNumber: rootParty?.gstNumber || null,
            partyPanNumber: rootParty?.panNumber || null,
            partyState: rootParty?.state || null,
            partyAddress: rootParty?.address || null,
            partyAdd1: rootParty?.add1 ?? null,
            partyAdd2: rootParty?.add2 ?? null,
            partyAdd3: rootParty?.add3 ?? null,
            partyCity: rootParty?.city ?? null,
            partyPinCode: rootParty?.pinCode ?? null,
            gstNumber:
              rootParty?.gstNumber ||
              billingPartyCompany?.gstNumber ||
              partyCompany?.gstNumber ||
              null,
            panNumber:
              rootParty?.panNumber || partyCompany?.panNumber || null,
            state: rootParty?.state || partyCompany?.state || null,
            parentCompanyAddress: partyCompany?.address || null,
            parentAdd1: partyCompany?.add1 ?? null,
            parentAdd2: partyCompany?.add2 ?? null,
            parentAdd3: partyCompany?.add3 ?? null,
            parentCity: partyCompany?.city ?? null,
            parentPinCode: partyCompany?.pinCode ?? null,
            stamp: invoiceInfo.stamp || null,
            roNumber: invoiceInfo.roNumber || null,
            parentCompanyName:
              bdfId?.parentCompanyId?.name ||
              bdfId?.parentCompanyName ||
              bdfId?.brandId?.partyCompany?.name ||
              null,
            splitParentCompanyName: billingPartyCompany?.name || null,
            splitGSTNumber: billingPartyCompany?.gstNumber || null,
            splitParentCompanyAddress: billingPartyCompany?.address || null,
            splitAdd1: billingPartyCompany?.add1 ?? null,
            splitAdd2: billingPartyCompany?.add2 ?? null,
            splitAdd3: billingPartyCompany?.add3 ?? null,
            splitCity: billingPartyCompany?.city ?? null,
            splitPinCode: billingPartyCompany?.pinCode ?? null,
            splitAmount: responseData?.invoiceInfo?.billingId?.subTotal || null,
            aliasPartyName: responseData?.invoiceInfo?.aliasPartyName || null,
            remark: bdfId?.remark || null,
            invoiceRemark:
              responseData?.invoiceInfo?.remark ||
              responseData?.invoiceInfo?.invoiceRemark ||
              null,
            invoiceSubRemark:
              responseData?.invoiceInfo?.subRemark ||
              responseData?.invoiceInfo?.invoiceSubRemark ||
              null,
            brandName:
              rootBrand?.brandName ||
              responseData?.invoiceInfo?.brandName ||
              invoiceInfo?.bdfId?.brandId?.brandName ||
              null,
            campaignName: bdfId?.campaignName || null,
            agencyCommission: invoiceInfo?.agencyCommission || 0,
            campaignDuration: bdfId?.campaignDuration || null,
            bdfType: bdfId?.bdfType,
            printingCharge: responseData?.invoiceInfo?.printingCharge || 0,
            mountingCharge: responseData?.invoiceInfo?.mountingCharge || 0,
            createdAt: responseData?.invoiceInfo?.createdAt || 0,
            createdBy: responseData?.invoiceInfo?.createdBy?.name,
            AckDate: responseData?.invoiceInfo?.AckDate || null,
            AckNo: responseData?.invoiceInfo?.AckNo || null,
            IRN: responseData?.invoiceInfo?.IRN || null,
            billNumber: responseData?.invoiceInfo?.billNumber || null,
            billedSuffixInvs: billedSuffixInvs,
            billedInvs:
              billedInvs?.map((inv) => ({
                _id: inv?.invId?._id || null,
                amount: inv?.amount || null,
                startDate: inv?.startDate || null,
                endDate: inv?.endDate || null,
                height: inv?.invId?.height || null,
                width: inv?.invId?.width || null,
                locationName: inv?.invId?.locations?.name || null,
                CodeNo: inv?.invId?.CodeNo || null,
                unit: inv?.invId?.unit || null,
                isTrading: inv?.invId?.isTrading || false,
                ownedBy: inv?.invId?.ownedBy || null,
              })) || [],
            inventories: bdfId?.inventories
              ? bdfId?.inventories
                .filter((inv) => {
                  // Filter inventories to match those in billedInvs by their _id
                  return billedInvs.some(
                    (billedInv) => billedInv?.invId?._id === inv?.invId?._id
                  );
                })
                .map((inv) => ({
                  _id: inv?.invId?._id || false,
                  locationName: inv?.invId?.locations?.name || null,
                  CodeNo: inv?.invId?.CodeNo || null,
                  suffix: inv?.invId?.suffix || "HO",
                  isTrading: inv?.invId?.isTrading || false,
                  ownedBy: inv?.invId?.ownedBy || false,
                  rpm: inv?.rpm || null,
                  printingCharge: inv?.printingCharge || 0,
                  mountingCharge: inv?.mountingCharge || 0,
                  specialRate: inv?.specialRate || null,
                  specialRatePerMonth: inv?.specialRatePerMonth || 0,
                  startDate: inv?.startDate || null,
                  endDate: inv?.endDate || null,
                }))
              : [],
            suffixInventories:
              bdfId?.suffixInventories?.map((inv) => ({
                _id: inv?._id,
                specialRate: inv?.specialRate || 0,
                purchaseRate: inv?.purchaseRate || 0,
                suffixCode: inv?.suffixCode || null,
                suffixInfo: inv?.suffixInfo || null,
                vendor: inv?.vendor || null,
              })) || [],
            //taxes
            taxType: invoiceInfo?.taxType || 0,
            IGST: responseData?.invoiceInfo?.IGST || 0,
            SGST: responseData?.invoiceInfo?.SGST || 0,
            CGST: responseData?.invoiceInfo?.CGST || 0,
            municipalTax: invoiceInfo?.municipalTax || 0,
            otherTaxes: invoiceInfo?.otherTaxes || 0,
            round: invoiceInfo?.round || 0,
            isFromSub: Boolean(invoiceInfo?.isFromSub),
          });

          // let totalRate = bdfId?.inventories?.reduce((acc, next) => {
          //   return (
          //     acc +
          //     (Number(next?.specialRate) || 0) +
          //     (Number(next?.mountingCharge) || 0) +
          //     (Number(next?.printingCharge) || 0) +
          //     (Number(next?.innovationCharge) || 0)
          //   ); // Ensures specialRate is a number, defaults to 0 if undefined
          // }, 0);

          // if (bdfId?.suffixInventories?.length > 0) {
          //   totalRate += bdfId.suffixInventories.reduce(
          //     (acc, next) => acc + (Number(next?.specialRate) || 0),
          //     0
          //   );
          // }

          // Now calculate the subTotal
          // let totalRate = 0;

          // // Filter the inventories to match those in billedInvs
          // const filteredInventories = bdfId?.inventories.filter((inv) => {
          //   return billedInvs.some(
          //     (billedInv) => billedInv?.invId?._id === inv?.invId?._id
          //   );
          // });

          // // Sum up the required charges and amount
          // filteredInventories.forEach((inv) => {
          //   const matchedBilledInv = billedInvs.find(
          //     (billedInv) => billedInv?.invId?._id === inv?.invId?._id
          //   );
          //   if (matchedBilledInv) {
          //     totalRate +=
          //       // (Number(inv?.mountingCharge) || 0) +
          //       // (Number(inv?.printingCharge) || 0) +
          //       (Number(inv?.innovationCharge) || 0) +
          //       (Number(matchedBilledInv?.amount) || 0);
          //   }
          // });

          // // ✅ Add overall invoice-level mounting and printing charges
          // totalRate +=
          //   (Number(responseData?.invoiceInfo?.mountingCharge) || 0) +
          //   (Number(responseData?.invoiceInfo?.printingCharge) || 0);

          // setSubTotal(totalRate);

          // return responseData;
        } else {
          notification.error({
            message: responseData?.message || "Failed to fetch the sales order",
          });
        }
      }
    } catch (error) {
      notification.error({
        message: error.message,
      });
    }
  };

  return (
    <mainContext.Provider
      value={{
        id,
        setId: handleSetId,
        preservePageNumberOnNextListMount,
        setPreservePageNumberOnNextListMount,
        searchQuery,
        setSearchQuery,
        pageSize,
        setPageSize,
        pageNumber,
        setPageNumber,
        fetchBillings,
        salesMen,
        fetchSalesMen,
        createdByFilter,
        setCreatedByFilter,
        campaignDateRange,
        setCampaignDateRange,
        salesPersonFilter,
        setSalesPersonFilter,
        salesPersonOptions,
        salesPersonLoading,
        financialYear,
        setFinancialYear,
        fetchToggle,
        setFetchToggle,
        totalOrders,
        searchToggle,
        billings,
        setBillings,
        justView,
        setJustView,
        loading,
        fetchTotalBillingInvoices,
        fetchTotalIsArchivedBillingInvoices,
        totalInvoices,
        billingInvoiceIds,
        billingInvoices,
        isArchivedbillingInvoices,
        cancelInvoice,
        getIrnDetails,
        checkAuthToken,
        invoiceData,
        setInvoiceData,
        AuthToken,
        generateEInvoice,
        remark,
        setRemark,
        getAllSubInvoice,
        allSubInvoices,
        setAllSubInvoices,
        totalSubInvoices,
        cancelBillingInvoice,
        archivedInvoiceData,
        fetchArchivedInvoiceDataByID,
        setArchivedInvoiceData,
        generateCreditNoteGov,
        isModalOpen,
        openModal,
        closeModal,
        fetchPartiesAndBrands,
        parties,
        brands,
        nextBillNumber,
        fetchNextBillNumber,
        consolidatedMode,
        setConsolidatedMode,
        consolidatedBillingIds,
        setConsolidatedBillingIds,
      }}
    >
      {props.children}
    </mainContext.Provider>
  );
};

export default MainState;
